import {OrganizationUnitStats} from "arteco-api-client-ts";
import {FormControlLabel, Switch, Typography} from "@mui/material";
import React, {useState} from "react";
import {LChart, LChartSeries, LineChart} from "../../../../components/chart/line_chart";
import {colors} from "../../../../components/utils/colors";

export interface OrganizationUnitsProps {
	data: OrganizationUnitStats | undefined;
}

export const OrganizationUnits = ({data}: OrganizationUnitsProps) => {

	const [accumulated, setAccumulated] = useState<boolean>(true);

	interface LChartSeriesPlus extends LChartSeries {
		pos: number;
	}

	const lineChart = (data: OrganizationUnitStats): LChart => {
		const xAxisData: string[] = [];
		const seriesData: LChartSeriesPlus[] = [];
		data.units?.forEach((unit, i) => {
			seriesData.push({
				label: unit.label as string,
				color: colors[i % colors.length],
				values: [],
				pos: i
			})
		});

		//FIXME incluir ARTECO
		// Promediar resultado

		const sums = new Map<string, number>();

		data.lines?.forEach((line) => {
			xAxisData.push(line.year + "-" + line.month);
			line.lines?.forEach(subline => {
				const org = seriesData.find(unit => unit.label == subline.organizationUnitName);
				if (org) {
					const bills = subline.totalBills || 0;
					const payrolls = subline.totalPayrolls || 0;
					const diff = bills - payrolls;

					const k = subline.organizationUnitName as string;
					let sum = sums.get(k) || 0;
					sum += diff;
					sums.set(k, sum);

					if (accumulated) {
						seriesData[org.pos].values.push(sum);
					} else {
						seriesData[org.pos].values.push(diff);
					}
				}
			});

		});

		return {
			xAxisData,
			seriesData
		}
	}

	return (
		<>
			{data && (
				<>
					<Typography mt={4} mb={2} variant="h6" color="textSecondary">
						DETALLE DE LAS UNIDADES ORGANIZATIVAS
					</Typography>
					<FormControlLabel labelPlacement={"start"}
									  control={<Switch checked={accumulated}
													   onChange={(e, v) => {
														   setAccumulated(v);
													   }}/>} label={accumulated ? "Acumulado" : "Mensual"}/>

					<LineChart data={lineChart(data)}/>


				</>
			)}
		</>
	);
}